import localForage from "localforage"
const uuidv1 = require('uuid/v1');
export const localDataProvider = (declaredResources = [], primaryDataProvider = {}) => {
    const isLocalResource = (resource) => {
        return declaredResources.find(declaredResurce => declaredResurce.name === resource) ? true : false;
    }
    const ensureData = async (resource) => {
        const declaredResource = declaredResources.find(declaredResource => declaredResource.name === resource)
        const keys = await localForage.keys()
        if (keys.find(key => key === declaredResource.name)) {
            return;
        }
        return (await localForage.setItem(declaredResource.name, declaredResource.defaultState.map(r => ({ ...r, id: uuidv1() }))))
    }

    let providerMethods = ({
        getList: async (resource, params) => {
            const localItems = await localForage.getItem(resource)
            return {
                total: localItems.length,
                // data: results.map(o => ({ id: o.id, ...o.attributes }))
                data: localItems
            }
        },
        getOne: async (resource, params) => {
            const { id } = params
            const localItems = await localForage.getItem(resource)
            return {
                data: localItems.find(localItem => localItem.id === id)
            }
        },
        getMany: async (resource, params) => {
            const { ids } = params
            const localItems = (await localForage.getItem(resource)).filter(localItem => {
                return ids.findIndex(id => localItem.id) > -1
            })
            return {
                data: localItems,
                count: localItems.length
            }
        },
        getManyReference: async (resource, params) => {
            return {
                data: [],
                count: 0
            }
        },
        create: async (resource, params) => {
            let localItems = (await localForage.getItem(resource))
            const item = {
                id: uuidv1(),
                ...params.data
            }
            localItems.push(item)
            await localForage.setItem(resource, localItems)
            return { data: item }
        },
        update: async (resource, params) => {
            let localItems = (await localForage.getItem(resource))
            const { id, data } = params
            let index = localItems.findIndex(localItem => localItem.id === id);
            const item = { ...localItems[index], ...data }
            localItems[index] = item
            await localForage.setItem(resource, localItems)
            return { data: item }
        },

        updateMany: async (resource, params) => {
            return {}
        },

        delete: async (resource, params) => {
            let localItems = (await localForage.getItem(resource))
            const { id } = params
            localItems = localItems.filter(localItem => localItem.id !== id);
            await localForage.setItem(resource, localItems)
            return { data: localItems }
        },

        deleteMany: async (resource, params) => {
            let localItems = (await localForage.getItem(resource))
            const { ids } = params
            ids.map((key) => localItems = localItems.filter(localItem => localItem.id !== key))
            await localForage.setItem(resource, localItems)
            return { data: localItems }
        },
    })
    let main = {}
    Object.keys(providerMethods).forEach((key) => {
        main[key] = async function (resource, params) {
            if (!isLocalResource(resource)) return primaryDataProvider[key](resource, params)
            await localForage.ready()
            await ensureData(resource)
            return providerMethods[key](resource, params)
        }
    })
    return main
}